<template>
  <div v-if="candidate">
    <div class="modal fade" role="dialog" ref="providercandidatedetailmodal">
      <div class="modal-dialog modal-md">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new update">
            <div class="row">
              <div class="col-sm-10">
                <h4>On Boarding</h4>
                <h6 v-if="candidate.stringModifiedDate">
                  Last Updated: {{ candidate.stringModifiedDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="row cRow">
                    <div class="col-sm-12">
                      <h4>
                        Candidates
                        <span class="candidate-status">({{ candidate.status }})</span>
                      </h4>
                      <ul
                        class="nav nav-tabs nav-justified tabs-mini-form"
                        style="padding-bottom: 15px"
                      >
                        <li :class="[activeTab === 'provider' ? 'active' : '']">
                          <a
                            href="#provider-candidate"
                            data-toggle="tab"
                            @click="activeTab = 'provider'"
                          >
                            <span>Provider</span>
                          </a>
                        </li>
                        <li :class="[activeTab === 'driver' ? 'active' : '']">
                          <a
                            href="#driver-candidate"
                            data-toggle="tab"
                            @click="activeTab = 'driver'"
                          >
                            <span>Driver</span>
                          </a>
                        </li>
                        <li :class="[activeTab === 'vehicle' ? 'active' : '']">
                          <a
                            href="#vehicle-candidate"
                            data-toggle="tab"
                            @click="activeTab = 'vehicle'"
                          >
                            <span>Vehicle</span>
                          </a>
                        </li>
                      </ul>
                      <div class="tab-content">
                        <div
                          id="provider-candidate"
                          class="tab-pane fade"
                          :class="[activeTab === 'provider' ? 'in active' : '']"
                        >
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="logo-provider" v-show="providerImagePreview">
                                <img :src="providerImagePreview" alt />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required">Company Name</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="candidate.name"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required">Company Email</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="candidate.email"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label>Company Alternate Email</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="candidate.alternateEmail"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <label class="required">Company Phone</label>
                              <div class="row">
                                <div class="col-sm-3">
                                  <div class="form-group">
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="candidate.phoneCode"
                                      disabled
                                    />
                                  </div>
                                </div>
                                <div class="col-sm-9">
                                  <div class="form-group">
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="candidate.phoneNumber"
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <label>Company Alternate Phone</label>
                              <div class="row">
                                <div class="col-sm-3">
                                  <div class="form-group">
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="candidate.alternatePhoneCode"
                                      disabled
                                    />
                                  </div>
                                </div>
                                <div class="col-sm-9">
                                  <div class="form-group">
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="candidate.alternatePhoneNumber"
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required">
                                  Operating City
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="candidate.operatingCity"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required">
                                  Currency, Decimal &amp; Time Format
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="candidate.regionFormatName"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="cursor-pointer">
                                  <input
                                    type="checkbox"
                                    class="control-checkbox"
                                    :value="candidate.isSoleProprietor"
                                    v-model="candidate.isSoleProprietor"
                                    disabled
                                  />
                                  <span class="pl-5 v-align-middle">
                                    Is Sole Proprietor / Independent Operator
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="cursor-pointer">
                                  <input
                                    type="checkbox"
                                    class="control-checkbox"
                                    :value="candidate.isSalesTaxApplicable"
                                    v-model="candidate.isSalesTaxApplicable"
                                    disabled
                                  />
                                  <span class="pl-5 v-align-middle">
                                    VAT/Sales Tax Applicable
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="candidate.isSalesTaxApplicable">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required">VAT/Sales Tax Number</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="candidate.salesTaxNumber"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            v-if="
                              candidate.paymentMethod.toLowerCase() === 'banktransfer'
                            "
                          >
                            <div class="row">
                              <div class="col-sm-12">
                                <div class="form-group">
                                  <label class="required">Bank Account Owner</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="candidate.bankConfiguration.accountOwner"
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-sm-12">
                                <div class="form-group">
                                  <label class="required">Bank Account Number</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="candidate.bankConfiguration.accountNumber"
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-sm-12">
                                <div class="form-group">
                                  <label>Bank International Account Number</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="
                                      candidate.bankConfiguration
                                        .internationalAccountNumber
                                    "
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-sm-12">
                                <div class="form-group">
                                  <label>Bank Swift</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="candidate.bankConfiguration.swift"
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-else-if="candidate.paymentMethod.toLowerCase() === 'paypal'"
                          >
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required">PayPal Email</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="candidate.paypalConfiguration.email"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required">Company City</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="candidate.city"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required">Company Address</label>
                                <textarea
                                  class="form-control"
                                  rows="4"
                                  v-model="candidate.location.address"
                                  disabled
                                ></textarea>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="candidate.documents">
                            <div class="col-sm-12">
                              <label>Documents </label>
                            </div>
                            <div class="table-responsive table-p15">
                              <table class="table table-hover table-fix">
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>Size</th>
                                    <th>Status</th>
                                    <th class="text-center">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="item in candidate.documents" :key="item.id">
                                    <td>{{ item.name }}</td>
                                    <td>{{ printFileSize(item.size) }}</td>
                                    <td>
                                      <span
                                        :data-toggle="
                                          !!item.status.toLowerCase() === 'rejected'
                                            ? 'tooltip'
                                            : false
                                        "
                                        :title="item.rejectedReason"
                                      >
                                        {{ item.status }}
                                      </span>
                                    </td>
                                    <td class="text-center">
                                      <div class="button-action-wrapper">
                                        <button
                                          v-if="item.status.toLowerCase() === 'requested'"
                                          class="btn btn-default"
                                          type="button"
                                          @click="approveProviderDocument(item.id)"
                                        >
                                          <span>Approve</span>
                                        </button>
                                        <button
                                          v-if="item.status.toLowerCase() === 'requested'"
                                          class="btn btn-default sts-danger"
                                          type="button"
                                          @click="
                                            openRejectModal(item.id, 'Provider Document')
                                          "
                                        >
                                          <span>Reject</span>
                                        </button>
                                        <button
                                          class="btn btn-default --green35"
                                          type="button"
                                          @click="viewProviderDocument(item.id)"
                                        >
                                          <span>View</span>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div
                          id="driver-candidate"
                          class="tab-pane fade"
                          :class="[activeTab === 'driver' ? 'in active' : '']"
                        >
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required">Name</label>
                                <div class="row">
                                  <div class="col-sm-3">
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="candidate.driverCandidate.title"
                                      disabled
                                    />
                                  </div>
                                  <div class="col-sm-9">
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="candidate.driverCandidate.fullName"
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label>Email</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="candidate.driverCandidate.email"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label>Alternate Email</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="candidate.driverCandidate.alternateEmail"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <label class="required">Phone</label>
                              <div class="row">
                                <div class="col-sm-3">
                                  <div class="form-group">
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="candidate.driverCandidate.phoneCode"
                                      disabled
                                    />
                                  </div>
                                </div>
                                <div class="col-sm-9">
                                  <div class="form-group">
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="candidate.driverCandidate.phoneNumber"
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <label>Alternate Phone</label>
                              <div class="row">
                                <div class="col-sm-3">
                                  <div class="form-group">
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="
                                        candidate.driverCandidate.alternatePhoneCode
                                      "
                                      disabled
                                    />
                                  </div>
                                </div>
                                <div class="col-sm-9">
                                  <div class="form-group">
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="
                                        candidate.driverCandidate.alternatePhoneNumber
                                      "
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="
                              candidate.driverCandidate.documents &&
                              !candidate.driverCandidate.isExisting
                            "
                          >
                            <div class="table-responsive table-p15">
                              <table class="table table-hover table-fix">
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>Size</th>
                                    <th>Status</th>
                                    <th class="text-center">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="item in candidate.driverCandidate.documents"
                                    :key="item.id"
                                  >
                                    <td>{{ item.name }}</td>
                                    <td>{{ printFileSize(item.size) }}</td>
                                    <td>
                                      <span
                                        :data-toggle="
                                          !!item.status.toLowerCase() === 'rejected'
                                            ? 'tooltip'
                                            : false
                                        "
                                        :title="item.rejectedReason"
                                      >
                                        {{ item.status }}
                                      </span>
                                    </td>
                                    <td class="text-center">
                                      <div class="button-action-wrapper">
                                        <button
                                          v-if="item.status.toLowerCase() === 'requested'"
                                          class="btn btn-default"
                                          type="button"
                                          @click="approveDriverDocument(item.id)"
                                        >
                                          <span>Approve</span>
                                        </button>
                                        <button
                                          v-if="item.status.toLowerCase() === 'requested'"
                                          class="btn btn-default sts-danger"
                                          type="button"
                                          @click="
                                            openRejectModal(item.id, 'Driver Document')
                                          "
                                        >
                                          <span>Reject</span>
                                        </button>
                                        <button
                                          class="btn btn-default --green35"
                                          type="button"
                                          @click="
                                            viewDriverDocument(
                                              candidate.providerCandidateId,
                                              item.id
                                            )
                                          "
                                        >
                                          <span>View</span>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div
                          id="vehicle-candidate"
                          class="tab-pane fade"
                          :class="[activeTab === 'vehicle' ? 'in active' : '']"
                        >
                          <div class="form-group">
                            <label class="required">Type</label>
                            <div class="d-flex">
                              <label
                                class="cursor-pointer"
                                v-for="(item, index) in vehicleTypes"
                                :key="index"
                                :class="{'pl-20': index > 0}">
                                <input
                                  type="radio"
                                  class="control-radio"
                                  :value="item.text"
                                  v-model="candidate.vehicleCandidate.type"
                                  disabled
                                />
                                <span class="pl-5 font-weight-normal v-align-middle">
                                  {{ item.text }}
                                </span>
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required">Class</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="candidate.vehicleCandidate.className"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required">Color</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="candidate.vehicleCandidate.feature.color"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required">Manufacturer</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="candidate.vehicleCandidate.factoryName"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required">Model</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="candidate.vehicleCandidate.brandName"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <!-- <div class="form-group">
                            <label class="required">Transmission</label>
                            <div class="btn-group-radio">
                              <label
                                class="wrap-radio"
                                v-for="(item, index) in vehicleTransmissions"
                                :key="index"
                              >
                                {{ item.text }}
                                <input
                                  type="radio"
                                  name="transmission-type"
                                  :value="item.text"
                                  v-model="
                                    candidate.vehicleCandidate.feature.transmission
                                  "
                                  disabled
                                />
                                <span class="bullet-mark"></span>
                              </label>
                            </div>
                          </div> -->
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <div class="row">
                                  <div class="col-sm-6">
                                    <label class="required">Plate No.</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="candidate.vehicleCandidate.plateNumber"
                                      disabled
                                    />
                                  </div>
                                  <div class="col-sm-6">
                                    <label class="required">Year Manufactured</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="
                                        candidate.vehicleCandidate.feature
                                          .yearManufactured
                                      "
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <div class="row">
                                  <div class="col-sm-6 prz">
                                    <label class="required">Pax Capacity</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="
                                        candidate.vehicleCandidate.feature.paxCapacity
                                      "
                                      disabled
                                    />
                                  </div>
                                  <div class="col-sm-6">
                                    <label class="required">Doors</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="candidate.vehicleCandidate.feature.doors"
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> -->
                          <!-- <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <div class="row">
                                  <div class="col-sm-6 prz">
                                    <label class="required">Large Bag. Capacity</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="
                                        candidate.vehicleCandidate.feature
                                          .largeBaggageCapacity
                                      "
                                      disabled
                                    />
                                  </div>
                                  <div class="col-sm-6">
                                    <label class="required">Small Bag. Capacity</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="
                                        candidate.vehicleCandidate.feature
                                          .smallBaggageCapacity
                                      "
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> -->
                          <div class="form-group">
                            <label class="cursor-pointer">
                              <input
                                type="checkbox"
                                class="control-checkbox"
                                v-model="candidate.vehicleCandidate.feature.hasAirConditioning"
                                disabled
                              />
                              <span class="pl-5 font-weight-normal v-align-middle">
                                Air Conditioning
                              </span>
                            </label>
                          </div>
                          <div class="form-group">
                            <label class="required">Operation</label>
                            <div class="d-flex">
                              <label
                                class="cursor-pointer"
                                v-for="(item, index) in vehicleOperations"
                                :key="index"
                                :class="{'pl-20': index > 0}">
                                <input
                                  type="checkbox"
                                  class="control-checkbox"
                                  :value="item.text"
                                  v-model="candidate.vehicleCandidate.operations"
                                  disabled
                                />
                                <span class="pl-5 font-weight-normal v-align-middle">
                                  {{ humanize(item.text) }}
                                </span>
                              </label>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="
                              candidate.vehicleCandidate.documents &&
                              !candidate.vehicleCandidate.isExisting
                            "
                          >
                            <div class="table-responsive table-p15">
                              <table class="table table-hover table-fix">
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>Size</th>
                                    <th>Status</th>
                                    <th class="text-center">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="item in candidate.vehicleCandidate.documents"
                                    :key="item.id"
                                  >
                                    <td>{{ item.name }}</td>
                                    <td>{{ printFileSize(item.size) }}</td>
                                    <td>
                                      <span
                                        :data-toggle="
                                          !!item.status.toLowerCase() === 'rejected'
                                            ? 'tooltip'
                                            : false
                                        "
                                        :title="item.rejectedReason"
                                      >
                                        {{ item.status }}
                                      </span>
                                    </td>
                                    <td class="text-center">
                                      <div class="button-action-wrapper">
                                        <button
                                          v-if="item.status.toLowerCase() === 'requested'"
                                          class="btn btn-default"
                                          type="button"
                                          @click="approveVehicleDocument(item.id)"
                                        >
                                          <span>Approve</span>
                                        </button>
                                        <button
                                          v-if="item.status.toLowerCase() === 'requested'"
                                          class="btn btn-default sts-danger"
                                          type="button"
                                          @click="
                                            openRejectModal(item.id, 'Vehicle Document')
                                          "
                                        >
                                          <span>Reject</span>
                                        </button>
                                        <button
                                          class="btn btn-default --green35"
                                          type="button"
                                          @click="
                                            viewVehicleDocument(
                                              candidate.providerCandidateId,
                                              item.id
                                            )
                                          "
                                        >
                                          <span>View</span>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="modal-footer"
                        v-if="candidate.status.toLowerCase() === 'requested'"
                      >
                        <button
                          class="btn btn-primary"
                          @click="openFullyApprovalDialog(candidate.providerCandidateId)"
                        >
                          Approve
                        </button>
                        <button
                          class="btn btn-default sts-danger"
                          @click="openRejectModal(candidate.providerCandidateId, 'All')"
                        >
                          Reject
                        </button>
                        <!-- <button
                          v-if="!candidate.isMandatoryDocumentExist"
                          class="btn btn-default"
                          @click="sendMandatoryDocument(candidate.providerCandidateId)"
                        >
                          Send Docs
                        </button> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
          <!-- /.modal-body -->
        </div>
        <!-- /.modal-content -->
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="rejectmodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>Reject {{ rejectModel.option }}</h4>
                <h6>Please fill all information below.</h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.rejectModel.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submitReject">
                    <div class="form-group">
                      <label class="required">Reason</label>
                      <textarea
                        class="form-control"
                        rows="3"
                        v-model="rejectModel.reason"
                      ></textarea>
                      <div
                        class="text-right word-count"
                        v-if="rejectModel.reason && rejectModel.reason !== ''"
                      >
                        {{ rejectModel.reason.length }} from
                        {{ $v.rejectModel.reason.$params.maxLength.max }} characters
                      </div>
                      <div v-if="isSubmitted && $v.rejectModel.reason.$error">
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.rejectModel.reason.required"
                          >Reason is required</small
                        >
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.rejectModel.reason.maxLength"
                          >Reason must be less than
                          {{ $v.rejectModel.reason.$params.maxLength.max }}
                          characters</small
                        >
                      </div>
                    </div>
                    <div class="modal-footer text-right">
                      <button type="submit" class="btn btn-primary">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <confirmModal
      :header="'On Boarding'"
      :content="'Are you sure want to approve this candidate?'"
      :cancel-label="'Cancel'"
      :submit-label="'Yes'"
      @submit="fullyApprove"
    />

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import confirmModal from "@/components/shared/ConfirmModal";
import onBoardingService from "@/services/master/onboarding/onBoardingService.js";

export default {
  components: {
    confirmModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
  },
  data() {
    return {
      isSubmitted: false,
      activeTab: "provider",
      fullyApproveId: null,
      vehicleTypes: [],
      vehicleTransmissions: [],
      vehicleOperations: [],
      rejectModel: { id: null, reason: null, option: null },
      allPermissions: [],
      providerImagePreview: null,
      candidate: null,
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      rejectModel: {
        reason: { required, maxLength: maxLength(300) },
      },
    };
  },
  created() {
    // subscribe message
    this.$eventBus.$on("initializeProviderCandidateDetail", this.initialize);
    this.$eventBus.$on("openModalProviderCandidateDetail", this.openModal);
  },
  beforeDestroy() {
    this.$eventBus.$off("initializeProviderCandidateDetail");
    this.$eventBus.$off("openModalProviderCandidateDetail");
    this.closeModal();
  },
  methods: {
    openModal() {
      this.activeTab = "provider";
      $(this.$refs.providercandidatedetailmodal).modal({
        backdrop: "static",
        keyboard: false,
      });
      $(this.$refs.providercandidatedetailmodal).css("overflow-y", "auto");
    },
    closeModal() {
      $(this.$refs.providercandidatedetailmodal).modal("hide");
    },
    resetValidation() {
      this.isSubmitted = false;
      this.$v.rejectModel.$reset();
    },
    async initialize(id, common) {
      try {
        this.isLoading = true;

        const profile = await this.$store.dispatch("user/getProfile");
        const permissions = profile.services[this.$route.name];
        if (permissions) {
          this.allPermissions = permissions;
        }

        if (this.isAllowToRead) {
          this.vehicleTypes = common.vehicleTypes;
          this.vehicleTransmissions = common.vehicleTransmissions;
          this.vehicleOperations = common.vehicleOperations;
          await this.getById(id);
        }

        this.openModal();
      } finally {
        this.isLoading = false;
      }
    },
    async getById(id) {
      const response = await onBoardingService.getById(id);
      this.candidate = response.data;
      this.candidate.location = this.candidate.location || {};
      this.candidate.bankConfiguration = this.candidate.bankConfiguration || {};
      this.candidate.contactPeople = this.candidate.contactPeople || [];
      this.candidate.driverCandidate = this.candidate.driverCandidate || {};
      this.candidate.vehicleCandidate = this.candidate.vehicleCandidate || {};
    },
    async viewProviderDocument(id) {
      try {
        this.isLoading = true;
        const response = await onBoardingService.viewProviderDocument(id);
        window.open(response.data, "_blank");
      } catch (error) {
        if (error.errors) {
          for (let i = 0; i < error.errors.length; i++) {
            this.$notification.error(error.errors[i], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async viewDriverDocument(providerCandidateId, documentId) {
      try {
        this.isLoading = true;
        const response = await onBoardingService.viewDriverDocument(
          providerCandidateId,
          documentId
        );
        window.open(response.data, "_blank");
      } catch (error) {
        if (error.errors) {
          for (let i = 0; i < error.errors.length; i++) {
            this.$notification.error(error.errors[i], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async viewVehicleDocument(providerCandidateId, documentId) {
      try {
        this.isLoading = true;
        const response = await onBoardingService.viewVehicleDocument(
          providerCandidateId,
          documentId
        );
        window.open(response.data, "_blank");
      } catch (error) {
        if (error.errors) {
          for (let i = 0; i < error.errors.length; i++) {
            this.$notification.error(error.errors[i], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async approveProviderDocument(id) {
      try {
        this.isLoading = true;
        await onBoardingService.approveProviderDocument({ documentId: id });
        await this.getById(this.candidate.providerCandidateId);
      } catch (error) {
        if (error.errors) {
          for (let i = 0; i < error.errors.length; i++) {
            this.$notification.error(error.errors[i], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async approveDriverDocument(id) {
      try {
        this.isLoading = true;
        await onBoardingService.approveDriverDocument({ documentId: id });
        await this.getById(this.candidate.providerCandidateId);
      } catch (error) {
        if (error.errors) {
          for (let i = 0; i < error.errors.length; i++) {
            this.$notification.error(error.errors[i], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async approveVehicleDocument(id) {
      try {
        this.isLoading = true;
        await onBoardingService.approveVehicleDocument({ documentId: id });
        await this.getById(this.candidate.providerCandidateId);
      } catch (error) {
        if (error.errors) {
          for (let i = 0; i < error.errors.length; i++) {
            this.$notification.error(error.errors[i], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async rejectProviderDocument(model) {
      try {
        this.isLoading = true;
        await onBoardingService.rejectProviderDocument({
          documentId: model.id,
          rejectedReason: model.reason,
        });
        await this.getById(this.candidate.providerCandidateId);
      } catch (error) {
        if (error.errors) {
          for (let i = 0; i < error.errors.length; i++) {
            this.$notification.error(error.errors[i], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async rejectDriverDocument(model) {
      try {
        this.isLoading = true;
        await onBoardingService.rejectDriverDocument({
          documentId: model.id,
          rejectedReason: model.reason,
        });
        await this.getById(this.candidate.providerCandidateId);
      } catch (error) {
        if (error.errors) {
          for (let i = 0; i < error.errors.length; i++) {
            this.$notification.error(error.errors[i], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async rejectVehicleDocument(model) {
      try {
        this.isLoading = true;
        await onBoardingService.rejectVehicleDocument({
          documentId: model.id,
          rejectedReason: model.reason,
        });
        await this.getById(this.candidate.providerCandidateId);
      } catch (error) {
        if (error.errors) {
          for (let i = 0; i < error.errors.length; i++) {
            this.$notification.error(error.errors[i], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    openFullyApprovalDialog(id) {
      this.fullyApproveId = id;
      $("#confirmmodal").modal({ backdrop: "static", keyboard: false });
    },
    async fullyApprove() {
      try {
        this.isLoading = true;
        await onBoardingService.fullyApprove({ providerCandidateId: this.fullyApproveId });
        this.closeModal();
        this.showNotifEmailMessageSent();
        this.$eventBus.$emit("initializeProviderCandidate");
      } catch (error) {
        if (error.errors) {
          for (let i = 0; i < error.errors.length; i++) {
            this.$notification.error(error.errors[i], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async fullyReject(model) {
      try {
        this.isLoading = true;
        await onBoardingService.fullyReject({ providerCandidateId: model.id, rejectedReason: model.reason });
        this.closeModal();
        this.showNotifEmailMessageSent();
      } catch (error) {
        if (error.errors) {
          for (let i = 0; i < error.errors.length; i++) {
            this.$notification.error(error.errors[i], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    openRejectModal(id, option) {
      this.rejectModel.id = id;
      this.rejectModel.option = option;
      this.rejectModel.reason = null;
      this.resetValidation();
      $(this.$refs.rejectmodal).modal({ backdrop: "static", keyboard: false });
    },
    closeRejectModal() {
      this.rejectModel.id = null;
      this.rejectModel.reason = null;
      this.rejectModel.option = null;
      this.resetValidation();
      $(this.$refs.rejectmodal).modal("hide");
    },
    async submitReject() {
      this.isSubmitted = true;
      this.$v.rejectModel.$touch();
      if (this.$v.rejectModel.$error) {
        return;
      }
      switch (this.rejectModel.option.toLowerCase()) {
        case "provider document":
          await this.rejectProviderDocument(this.rejectModel);
          break;
        case "driver document":
          await this.rejectDriverDocument(this.rejectModel);
          break;
        case "vehicle document":
          await this.rejectVehicleDocument(this.rejectModel);
          break;
        case "all":
          await this.fullyReject(this.rejectModel);
          break;
      }
      this.closeRejectModal();
    },
    async sendMandatoryDocument(id) {
      try {
        this.isLoading = true;
        await onBoardingService.sendMandatoryDocument({ providerCandidateId: id });
      } catch (error) {
        if (error.errors) {
          for (let i = 0; i < error.errors.length; i++) {
            this.$notification.error(error.errors[i], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    printFileSize(size) {
      return this.$helper.printFileSize(size);
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
    showNotifEmailMessageSent() {
      const timestamp = this.getFormattedTimestamp();
      this.$notification.success(`Message have been sent to ${this.candidate.email} at ${timestamp.time}, ${timestamp.date}.`, { title: "Success" });
    },
    getFormattedTimestamp() {
      const dt = new Date();
      const _day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(dt);
      const _month = new Intl.DateTimeFormat('en', { month: 'short' }).format(dt);
      const _year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(dt);
      const _time = new Intl.DateTimeFormat('en', { hour: '2-digit', minute: '2-digit' }).format(dt);

      return {
        date: `${_day} ${_month} ${_year}`,
        time: _time
      }
    }
  },
};
</script>

<style>
.candidate-status {
  color: #eb0011 !important;
  font-weight: 400;
  font-size: 0.8667rem;
}
</style>



// WEBPACK FOOTER //
// src/components/master/onboarding/ProviderCandidateDetail.vue